import { client } from "@/api-client";
import type {
  OwnerWithDogsDisplayOutput,
  TrainerDisplayOutput,
} from "@/api-types";
import { useUser } from "@/UserContext";

// Types from OpenAPI
// Intersection type for common fields
export type ProfileDisplayCommon = Pick<
  OwnerWithDogsDisplayOutput,
  "id" | "firstName" | "lastName" | "portraitFullPath" | "inviteCode"
>;

export const useOwnerProfileDisplay = () => {
  const user = useUser();

  const result = client.useQuery("get", "/owner/profile/display", undefined, {
    enabled: !!user.accountId && user.role === "owner",
  });

  return {
    profile: result.data as OwnerWithDogsDisplayOutput,
    isLoading: result.isLoading,
  };
};

export const useTrainerProfileDisplay = () => {
  const user = useUser();
  const result = client.useQuery("get", "/trainer/profile/display", undefined, {
    enabled: !!user.accountId && user.role === "trainer",
  });
  return {
    profile: result.data as TrainerDisplayOutput,
    isLoading: result.isLoading,
  };
};

export const useProfileDisplay = () => {
  const user = useUser();

  const endpoint =
    user.role === "trainer"
      ? "/trainer/profile/display"
      : "/owner/profile/display";
  const result = client.useQuery("get", endpoint, undefined, {
    enabled: !!user.accountId,
  });
  // Only return the intersection fields
  const profile = result.data && {
    id: result.data.id,
    firstName: result.data.firstName,
    lastName: result.data.lastName,
    portraitFullPath: result.data.portraitFullPath,
    inviteCode: result.data.inviteCode,
  };
  return {
    profile: profile,
    isLoading: result.isLoading,
  };
};
